import Select from "./core/selector";

class FeedbackWidget {
  private readonly feedbackWidget: HTMLElement;
  private readonly importantElements: HTMLElement[];
  private readonly showFormBtn: HTMLElement;
  private readonly submitBtn: HTMLElement;
  private readonly closeBtn: HTMLElement;

  constructor() {
    this.feedbackWidget = Select.byId("feedbackWidget");
    this.importantElements = this.detectOcclusionSensitiveElements();
    this.showFormBtn = Select.byId("showFeedbackForm");
    this.submitBtn = Select.byId("submitFeedback");
    this.closeBtn = Select.byId("closeFeedbackForm");

    this.showFormBtn.addEventListener("click", () => this.showFeedbackForm());
    this.submitBtn.addEventListener("click", () => this.submitFeedback());
    this.closeBtn.addEventListener("click", () => this.closeFeedbackForm(true));

    this.handleMainOcclusion();
    this.handleMinimization();

    window.addEventListener("scroll", () => {
      this.handleMainOcclusion();
      this.handleMinimization();
    });
  }

  public static shouldBeInitialized(): boolean {
    return Select.byId("feedbackWidget") !== null;
  }

  private detectOcclusionSensitiveElements(): HTMLElement[] {
    return Array.from(document.querySelectorAll("main, .hero"));
  }

  private showFeedbackForm(): void {
    const feedbackForm = Select.byId("feedbackForm");
    if (feedbackForm) {
      this.showFormBtn.classList.add("d-none");
      feedbackForm.classList.remove("d-none");
    }
  }

  private async submitFeedback(): Promise<void> {
    const feedback = Select.byId<HTMLTextAreaElement>("feedbackText").value;
    const email =
      Select.byId<HTMLInputElement>("emailAddress").value.trim() || null;

    if (!feedback) {
      return;
    }

    if (await this.sendFeedback(feedback, email)) {
      this.closeFeedbackForm(false);
    }
  }

  private closeFeedbackForm(showButton: boolean) {
    Select.byId<HTMLTextAreaElement>("feedbackText").value = "";
    Select.byId("feedbackForm")?.classList.add("d-none");
    if (showButton) {
      Select.byId("showFeedbackForm")?.classList.remove("d-none");
    }
  }

  private async sendFeedback(
    feedback: string,
    email: string | null
  ): Promise<boolean> {
    const currentUrl = window.location.href;
    const result = await fetch("/api/feedback", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: feedback,
        context: currentUrl,
        contact: email,
      }),
    });

    if (result.ok) {
      const toast = new bootstrap.Toast(Select.byId("successToast"));
      toast.show();
      return true;
    }
  }

  private handleMainOcclusion() {
    if (!this.feedbackWidget || !this.importantElements) {
      return;
    }

    const ocludesAnything = this.importantElements.find((e) =>
      this.ocludesElement(e)
    );

    if (ocludesAnything) {
      this.feedbackWidget.classList.add("opaque");
    } else {
      this.feedbackWidget.classList.remove("opaque");
    }
  }

  private ocludesElement(element: HTMLElement): boolean {
    const rect = element.getBoundingClientRect();
    const feedbackRect = this.feedbackWidget.getBoundingClientRect();

    return (
      feedbackRect.top <= rect.bottom &&
      feedbackRect.right - 70 <= rect.right &&
      feedbackRect.bottom >= rect.top &&
      feedbackRect.right >= rect.left
    );
  }

  private handleMinimization() {
    if (!this.feedbackWidget) {
      return;
    }

    if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
      this.feedbackWidget.classList.add("minimized");
    } else {
      this.feedbackWidget.classList.remove("minimized");
    }
  }
}

window.onload = () => {
  if (FeedbackWidget.shouldBeInitialized()) {
    new FeedbackWidget();
  }
};
